module.exports = __webpack_public_path__ + "static/media/german.a25c8f71.png";